import Colors from 'constants/Colors';

export default {
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    color: Colors.darkText,
  },
  container: {
    flex: 1,
    borderRadius: 6,
    backgroundColor: Colors.inputBg,
    padding: 4,
  },
  select: {
    width: '100%',
  },
  errorShadow: {
    boxShadow: `0.5px 1px 6px ${Colors.red}`,
  },
};
